import { Landmark, PieChart, CalendarClock } from "lucide-react";

const items = [
  {
    icon: Landmark,
    value: "Assets & debts",
    label: "One place for everything you own and owe",
  },
  {
    icon: PieChart,
    value: "Smart groups",
    label: "Gold, funds, cash, travel points & more",
  },
  {
    icon: CalendarClock,
    value: "Daily snapshots",
    label: "See how net worth moves over time",
  },
];

/**
 * Three quick capability call-outs in a hairline-divided row, echoing
 * the dashboard's Assets/Debts split footer.
 */
export default function LandingStats() {
  return (
    <section className="border-y border-vaulzo-hairline">
      <div className="mx-auto grid max-w-[800px] divide-y divide-vaulzo-hairline px-6 sm:grid-cols-3 sm:divide-x sm:divide-y-0">
        {items.map(({ icon: Icon, value, label }) => (
          <div key={value} className="py-8 sm:px-6 sm:first:pl-0 sm:last:pr-0">
            <Icon className="mb-3 h-5 w-5 text-vaulzo-accent" strokeWidth={1.7} />
            <p className="text-[15px] font-semibold text-vaulzo-ink">{value}</p>
            <p className="mt-1 text-sm leading-relaxed text-vaulzo-faint">{label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
